/**
 * Levágja a stringet a megadott hosszúságúra.
 * @param {string} str - A megadott string.
 * @param {number} maxLength - A maximális hossz.
 * @returns {string} A levágott string.
 */
module.exports.truncate = function truncate (str, maxLength) {
  if (str.length > maxLength) {
    return str.slice(0, Math.max(0, maxLength))
  }

  return str
}
